import {
  CLOSE_CLIENT_REMOVED_FAILURE,
  CLOSE_CLIENT_REMOVED_REQUEST,
  CLOSE_CLIENT_REMOVED_SUCCESS,
  MANAGE_OWNERSHIP_FAILURE,
  MANAGE_OWNERSHIP_REQUEST,
  MANAGE_OWNERSHIP_SUCCESS,
  UPDATE_CLIENT_VERIFICATION_FAILURE,
  UPDATE_CLIENT_VERIFICATION_REQUEST,
  UPDATE_CLIENT_VERIFICATION_RESET,
  UPDATE_CLIENT_VERIFICATION_SUCCESS,
  USERANALYTICS_FAILURE,
  USERANALYTICS_REQUEST,
  USERANALYTICS_SUCCESS,
  USERDETAIL_FAILURE,
  USERDETAIL_REQUEST,
  USERDETAIL_RESET,
  USERDETAIL_SUCCESS,
  USERSTATUS_FAILURE,
  USERSTATUS_REQUEST,
  USERSTATUS_RESET,
  USERSTATUS_SUCCESS,
} from './UserDetailContainer.constants';

export const userInfoAction = {
  request: data => ({
    type: USERDETAIL_REQUEST,
    data,
  }),
  success: data => ({
    type: USERDETAIL_SUCCESS,
    data,
  }),
  failure: error => ({
    type: USERDETAIL_FAILURE,
    error,
  }),
  reset: () => ({
    type: USERDETAIL_RESET,
  }),
};

export const changeUserStatusAction = {
  request: data => ({
    type: USERSTATUS_REQUEST,
    data,
  }),
  success: data => ({
    type: USERSTATUS_SUCCESS,
    data,
  }),
  failure: error => ({
    type: USERSTATUS_FAILURE,
    error,
  }),
  reset: () => ({
    type: USERSTATUS_RESET,
  }),
};

export const userAnalyticsAction = {
  request: data => ({
    type: USERANALYTICS_REQUEST,
    data,
  }),
  success: data => ({
    type: USERANALYTICS_SUCCESS,
    data,
  }),
  failure: error => ({
    type: USERANALYTICS_FAILURE,
    error,
  }),
};

export const updateClientVerificationAction = {
  request: data => ({
    type: UPDATE_CLIENT_VERIFICATION_REQUEST,
    data,
  }),
  success: data => ({
    type: UPDATE_CLIENT_VERIFICATION_SUCCESS,
    data,
  }),
  failure: error => ({
    type: UPDATE_CLIENT_VERIFICATION_FAILURE,
    error,
  }),
  reset: () => ({
    type: UPDATE_CLIENT_VERIFICATION_RESET,
  }),
};

export const manageOwnershipAction = {
  request: data => ({
    type: MANAGE_OWNERSHIP_REQUEST,
    data,
  }),
  success: data => ({
    type: MANAGE_OWNERSHIP_SUCCESS,
    data,
  }),
  failure: error => ({
    type: MANAGE_OWNERSHIP_FAILURE,
    error,
  }),
};

export const closeClientRemovedAction = {
  request: data => ({
    type: CLOSE_CLIENT_REMOVED_REQUEST,
    data,
  }),
  success: data => ({
    type: CLOSE_CLIENT_REMOVED_SUCCESS,
    data,
  }),
  failure: error => ({
    type: CLOSE_CLIENT_REMOVED_FAILURE,
    error,
  }),
};
